import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M764.611765,56 L990.494118,394.823529 L225.882353,394.823529 L225.882353,507.764706 L1920,507.764706 L1920,1011.82118 C1920,1035.65176 1889.16706,1042.54118 1877.64706,1021.76 C1819.59529,917.515294 1708.34824,846.588235 1581.17647,846.588235 C1394.82353,846.588235 1242.35294,999.058824 1242.35294,1185.41176 L1242.35294,1185.41176 L1174.58824,1185.41176 C1149.62824,1185.41176 1129.41176,1205.62824 1129.41176,1230.58824 L1129.41176,1230.58824 L1129.41176,1693.64706 C1129.41176,1712.84706 1131.67059,1732.04706 1135.05882,1750.11765 L1135.05882,1750.11765 L169.411765,1750.11765 C75.8964706,1750.11765 0,1674.33412 0,1580.70588 L0,1580.70588 L0,56 L764.611765,56 Z M1581.17647,1072.47059 C1643.40706,1072.47059 1694.11765,1123.18118 1694.11765,1185.41176 L1694.11765,1298.35294 L1468.23529,1298.35294 L1468.23529,1185.41176 C1468.23529,1123.18118 1518.94588,1072.47059 1581.17647,1072.47059 Z M1807.05882,1185.41176 C1807.05882,1060.83765 1705.86353,959.529412 1581.17647,959.529412 C1456.48941,959.529412 1355.29412,1060.83765 1355.29412,1185.41176 L1355.29412,1298.35294 L1242.35294,1298.35294 L1242.35294,1693.64706 C1242.35294,1787.04941 1318.36235,1863.05882 1411.76471,1863.05882 L1750.58824,1863.05882 C1843.99059,1863.05882 1920,1787.04941 1920,1693.64706 L1920,1298.35294 L1807.05882,1298.35294 L1807.05882,1185.41176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFileLockedSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconFileLockedSolid, _Component);

  var _super = _createSuper(IconFileLockedSolid);

  function IconFileLockedSolid() {
    _classCallCheck(this, IconFileLockedSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconFileLockedSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFileLocked",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFileLockedSolid.displayName = "IconFileLockedSolid";
  return IconFileLockedSolid;
}(Component);

IconFileLockedSolid.glyphName = 'file-locked';
IconFileLockedSolid.variant = 'Solid';
IconFileLockedSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFileLockedSolid;
export { IconFileLockedSolid };